import type { SelectedTemplateInfo } from '../types';
import { SelectedTemplateRow } from './SelectedTemplateRow';

export function SelectedTemplatesList({ templates }: { templates: SelectedTemplateInfo[] }) {
  return (
    <div className="pipeline-selected-templates" data-testid="pipeline-selected-templates">
      {templates.map(t => (
        <SelectedTemplateRow key={t.category} template={t} />
      ))}
    </div>
  );
}
